module.exports = __webpack_public_path__ + "static/media/29.7f5994ce.webp";